import 'highcharts/highcharts-more'
import Highcharts from 'highcharts/highstock'
import 'highcharts/modules/solid-gauge'
import { HighchartsReact } from 'highcharts-react-official'
import { useMemo } from 'react'

import type { Options } from 'highcharts/highstock'
import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  value: number
}

const SimpleGauge = ({ value }: Props): ReactElement => {
  const options: Options = useMemo(
    () => ({
      chart: {
        type: 'solidgauge',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      pane: {
        background: [
          {
            backgroundColor: '#E9E9E9',
            borderWidth: 0,
            innerRadius: '88%',
            // Track for Move
            outerRadius: '112%',
          },
        ],
        endAngle: 360,
        startAngle: 0,
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false,
          },
          linecap: 'round',
          rounded: true,
          stickyTracking: false,
        },
      },
      series: [
        {
          data: [
            {
              color: '#ff5301',
              innerRadius: '88%',
              radius: '112%',
              y: value !== 0 ? (value < 0 ? value - value * 2 : value) : null,
            },
          ],
          name: 'Move',
          type: 'solidgauge',
        },
      ],
      title: {
        text: '',
      },
      tooltip: {
        enabled: false,
      },
      yAxis: {
        lineWidth: 0,
        max: 100,
        min: 0,
        tickPositions: [],
      },
    }),
    [value]
  )

  const memoizedValue = useMemo(() => {
    if (value % 1 === 0 || value > 100 || value < -100) {
      return value.toFixed(0)
    }

    return value.toFixed(2)
  }, [value])

  return (
    <div className="simple-gauge-component">
      <HighchartsReact
        containerProps={{ style: { height: '99%', width: '100%' } }}
        highcharts={Highcharts}
        options={options}
      />
      <span className="percentage" style={{ color: '#ff5301' }}>
        {memoizedValue}%
      </span>
    </div>
  )
}

export default SimpleGauge
